import * as fromDatatype from '../datatype-library/index';

export interface bl_bi_report_query_template_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  filter_type: fromDatatype.VarcharDatatypeInterface;
  filter_query: fromDatatype.VarcharDatatypeInterface;
  filter_stored_procedure_json: fromDatatype.JsonDatatypeInterface;
  filter_json: fromDatatype.JsonDatatypeInterface;
  output_type: fromDatatype.VarcharDatatypeInterface;
  output_sql_type: fromDatatype.VarcharDatatypeInterface;
  output_sql_table: fromDatatype.VarcharDatatypeInterface;
  output_file_hdr_latest_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  report_hdr_guid: fromDatatype.GuidDataFieldInterface;
  execution_mode: fromDatatype.VrsnDataFieldInterface;
}

export class bl_bi_report_query_template_hdr_RowClass
  implements bl_bi_report_query_template_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  filter_type: fromDatatype.VarcharDatatypeInterface;
  filter_query: fromDatatype.VarcharDatatypeInterface;
  filter_stored_procedure_json: fromDatatype.JsonDatatypeInterface;
  filter_json: fromDatatype.JsonDatatypeInterface;
  output_type: fromDatatype.VarcharDatatypeInterface;
  output_sql_type: fromDatatype.VarcharDatatypeInterface;
  output_sql_table: fromDatatype.VarcharDatatypeInterface;
  output_file_hdr_latest_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  report_hdr_guid: fromDatatype.GuidDataFieldInterface;
  execution_mode: fromDatatype.VrsnDataFieldInterface;
}
